function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { styled } from '@mui/system';
import { TextField } from "@mui/material";
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import frLocale from 'date-fns/locale/fr';
import enCA from 'date-fns/locale/en-CA';
const StyledDesktopDatePicker = styled(DesktopDatePicker)({
  width: "100%"
});
const StyledTextField = styled(TextField)(({
  theme
}) => ({
  '& .MuiOutlinedInput-root': {
    "&:hover fieldset": {
      // sets the border color of the outlined variant
      borderColor: theme.palette.custom.textFieldHover
    }
  }
}));
class MonthPicker extends Component {
  state = {
    selectedDate: this.props.value
  };
  _handleDateChange = date => {
    const firstOfSelectedMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    this.setState({
      selectedDate: firstOfSelectedMonth
    });
    this.props.onChange(firstOfSelectedMonth);
  };
  render() {
    const {
      customStyle
    } = this.props;
    return /*#__PURE__*/React.createElement(LocalizationProvider, {
      dateAdapter: AdapterDateFns,
      adapterLocale: i18n.locale === "fr" ? frLocale : enCA
    }, /*#__PURE__*/React.createElement(StyledDesktopDatePicker, {
      sx: {
        ...customStyle
      },
      variant: "inline",
      views: ['year', 'month'],
      openTo: "year",
      label: i18n.t(tokens.labels.dates.monthAndYear),
      inputVariant: "outlined",
      fullWidth: true,
      value: this.state.selectedDate,
      onChange: this._handleDateChange,
      renderInput: params => /*#__PURE__*/React.createElement(StyledTextField, _extends({}, params, {
        inputProps: {
          ...params.inputProps,
          readOnly: true
        }
      }))
    }));
  }
}
export default MonthPicker;